export default __webpack_public_path__ + "static/media/telehealth.7fdea760.jpg";